import { createElement } from 'react';

import Image from 'next/image';

import { SPORT_ICONS, type SportVisual } from './sport-icons';

/**
 * Renders a sport's resolved picture the same way on every surface: the web
 * and native booking pickers, the app home Sports strip and Sports
 * management. Uploaded images fill a circle; glyphs follow the text colour.
 * Decorative: every caller renders the sport's name beside it.
 */
export function SportVisualView({
  visual,
  size,
  glyphSize = size,
  strokeWidth = 1.5,
}: {
  visual: SportVisual;
  size: number;
  glyphSize?: number;
  strokeWidth?: number;
}) {
  if (visual.kind === 'image') {
    return (
      <Image
        src={visual.src}
        alt=""
        width={size}
        height={size}
        unoptimized
        className="shrink-0 rounded-full object-cover"
        style={{ width: size, height: size }}
      />
    );
  }

  if (visual.kind === 'emoji') {
    return (
      <span
        aria-hidden="true"
        className="shrink-0 leading-none"
        style={{ fontSize: glyphSize * 0.85 }}
      >
        {visual.value}
      </span>
    );
  }

  return createElement(SPORT_ICONS[visual.key], {
    'aria-hidden': true,
    className: 'shrink-0',
    size: glyphSize,
    strokeWidth,
  });
}
